import { UIHeading4, UIText1 } from '@cian/ui-kit';
import { IconActionChevronDownSmall16, IconActionChevronUpSmall16 } from '@cian/ui-kit-design-tokens/icons';
import classNames from 'classnames';
import * as React from 'react';

import * as styles from './ChatbotMenuPinFilter.css';

type TProps = {
  menuText: string;
};

export const ChatbotMenuPinFilter: React.FC<TProps> = ({ menuText }) => {
  const [isShowText, setIsShowText] = React.useState<boolean>(false);
  const [isTextOverflowing, setIsTextOverflowing] = React.useState<boolean>(false);

  const textRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    const textElement = textRef.current;
    if (textElement && textElement.scrollHeight > textElement.clientHeight) {
      setIsTextOverflowing(true);
    }
  }, [menuText]);

  if (!menuText) {
    return null;
  }

  return (
    <div className={styles['container']}>
      <div ref={textRef} className={classNames(!isShowText && styles['hide-text'])}>
        <UIText1 color="text-secondary-default">{menuText}</UIText1>
      </div>
      {isTextOverflowing && (
        <div
          data-testid="toggle-button"
          className={classNames(styles['button'])}
          onClick={() => setIsShowText((prev: boolean) => !prev)}
        >
          <UIHeading4 color="text-main-default">{isShowText ? 'Свернуть' : 'Развернуть'}</UIHeading4>
          {isShowText ? (
            <IconActionChevronUpSmall16 color="icon-main-default"></IconActionChevronUpSmall16>
          ) : (
            <IconActionChevronDownSmall16 color="icon-main-default"></IconActionChevronDownSmall16>
          )}
        </div>
      )}
    </div>
  );
};
